import { memo } from 'react';
import { Avatar, Paragraph } from '@quickmd-llc/design-system';
import { formatProviderName, formatProviderNameWithTitle } from '@utils';
import { Provider } from '@types';

interface Props {
  provider: Provider;
  onClick: (provider: Provider) => void;
}

function SearchResult({ provider, onClick }: Props): JSX.Element {
  const providerNameWithTitle = formatProviderNameWithTitle(provider);
  const providerName = formatProviderName(provider);
  const { imageUrl } = provider;

  function handleClick() {
    onClick(provider);
  }

  return (
    <div
      onClick={handleClick}
      className="group flex cursor-pointer items-center gap-3 rounded-lg p-1 hover:bg-frost-20"
      data-testid={`pw_search-provider-${providerName}`}
    >
      <Avatar src={imageUrl} name={providerName} />

      <Paragraph className="group-hover:text-teal-60 font-semibold">
        {providerNameWithTitle}
      </Paragraph>
    </div>
  );
}

export default memo(SearchResult);
